import { render } from "./Termoland.vue?vue&type=template&id=16df480e"
import script from "./Termoland.vue?vue&type=script&lang=js"
export * from "./Termoland.vue?vue&type=script&lang=js"

import "./Termoland.vue?vue&type=style&index=0&id=16df480e&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__